import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { SelectComponent } from './select.component';

@NgModule({
    imports: [TwcModule, ReactiveFormsModule, CommonModule, TranslateModule],
    declarations: [SelectComponent],
    exports: [SelectComponent],
})
export class SelectModule {}
